import React, { useEffect, useState } from "react";
import { Hourglass, Loader2 } from "lucide-react";
import api, { formatMoney, formatNumber } from "../lib/api";
import { ExportButtons } from "../lib/exports";

const fecha = (v) => (v ? new Date(v).toLocaleDateString("es-ES") : "—");

export function RankingStockAntiguo({ segment, onOpenLab }) {
  const [d, setD] = useState(null);
  const [todos, setTodos] = useState(false);
  useEffect(() => {
    setD(null);
    api.get("/labs-resumen/stock-antiguo-ranking", { params: { segment } }).then((r) => setD(r.data)).catch(() => setD({ labs: [] }));
  }, [segment]);
  if (!d) return <div className="card p-5 mb-4 text-slate-500 flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Calculando stock antiguo…</div>;
  if (!d.labs.length) return null;
  const rows = todos ? d.labs : d.labs.slice(0, 10);
  const max = d.labs[0]?.eur || 1;
  return (
    <div className="card p-6 mb-4 border-l-4 border-red-500" data-testid="ranking-stock-antiguo">
      <div className="flex items-start justify-between gap-3 flex-wrap mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-red-600 font-bold flex items-center gap-1"><Hourglass size={11} /> Ranking</div>
          <h3 className="font-display text-xl font-bold">Laboratorios con más stock antiguo sin movimiento</h3>
          <p className="text-xs text-slate-500 mt-1">
            Stock que entró antes del {fecha(d.desde)} (hace más de 2 años) y no se ha vendido desde entonces:
            <b className="text-red-700"> {formatMoney(d.total)}</b> en {formatNumber(d.refs)} productos. Pulsa un laboratorio para ver su ficha.
          </p>
        </div>
        <ExportButtons filename={`stock-antiguo-laboratorios-${segment}`} title="Laboratorios con más stock antiguo sin movimiento" sheetName="Stock antiguo"
                       columns={[{ header: "Laboratorio", key: "laboratorio" }, { header: "Productos", key: "refs", align: "right" },
                                 { header: "Unidades", key: "uds", align: "right" },
                                 { header: "Valor PVP (€)", key: "eur", format: (v) => (v || 0).toFixed(2), align: "right" },
                                 { header: "% del total", key: "pct", format: (v) => (v || 0).toFixed(1), align: "right" }]}
                       rows={d.labs} testIdPrefix="ranking-stock-antiguo-export" />
      </div>
      <div className="overflow-x-auto">
        <table className="dense" data-testid="ranking-stock-antiguo-tabla">
          <thead><tr><th>#</th><th>Laboratorio</th><th className="num">Productos</th><th className="num">Unidades</th><th className="num">Valor PVP</th><th style={{ minWidth: 180 }}>% del total</th></tr></thead>
          <tbody>
            {rows.map((r, i) => {
              const clic = r.laboratorio !== "Sin laboratorio";
              return (
                <tr key={r.laboratorio} onClick={() => clic && onOpenLab(r.laboratorio)} className={clic ? "cursor-pointer" : ""}
                    data-testid={`ranking-stock-antiguo-fila-${i}`}>
                  <td className="font-mono text-xs text-slate-500">{i + 1}</td>
                  <td className="text-xs font-semibold">{r.laboratorio}</td>
                  <td className="num">{formatNumber(r.refs)}</td>
                  <td className="num">{formatNumber(r.uds)}</td>
                  <td className="num font-semibold text-red-700">{formatMoney(r.eur)}</td>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="h-2 flex-1 rounded-full bg-slate-100"><div className="h-2 rounded-full bg-red-500" style={{ width: `${(100 * r.eur) / max}%` }} /></div>
                      <span className="text-xs font-mono w-12 text-right">{String(r.pct).replace(".", ",")} %</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {d.labs.length > 10 && (
        <button onClick={() => setTodos((v) => !v)} className="mt-3 text-sm font-semibold text-slate-700 hover:underline" data-testid="ranking-stock-antiguo-todos">
          {todos ? "Ver solo los 10 primeros" : `Ver los ${d.labs.length} laboratorios`}
        </button>
      )}
    </div>
  );
}
